export const RewardItems = [
  {
    id: 1,
    image: "/assets/imgs/inventory/helperitem.png",
    label: "1000 Credits",
  },
  {
    id: 2,
    image: "/assets/imgs/inventory/helperitem.png",
    label: "2000 Credits",
  },
  { id: 3, image: "/assets/imgs/inventory/key.png", label: "5 keys", disabled: true },
  { id: 4, image: "/assets/imgs/inventory/key.png", label: "10 keys", disabled: true },
  { id: 5, image: "/assets/imgs/inventory/perkbox.png", label: "3 Perk box" },
  { id: 6, image: "/assets/imgs/inventory/perkbox.png", label: "5 Perk box" },
  { id: 7, image: "/assets/imgs/inventory/perkbox.png", label: "10 Perk box" },
  {
    id: 8,
    image: "/assets/imgs/inventory/frank-bgsmall.png",
    label: "Level 7",
  },
  { id: 9, image: "/assets/imgs/inventory/sam-bgsmall.png", label: "Level 7" },
  {
    id: 10,
    image: "/assets/imgs/inventory/jim-bgsmall.png",
    label: "Level 5",
  },
  { id: 11, image: "/assets/imgs/inventory/johnny-bgsmall.png", label: "Level 5" },
  { id: 12, image: "/assets/imgs/premium/unlimited.png", label: "6 month" },
  { id: 13, image: "/assets/imgs/premium/unlimited.png", label: "3 months" },
  { id: 14, image: "/assets/imgs/premium/unlimited.png", label: "1 months" },
  { id: 15, image: "/assets/imgs/premium/badge.png", label: "6 month" },
  { id: 16, image: "/assets/imgs/premium/badge.png", label: "3 months" },
  { id: 17, image: "/assets/imgs/premium/badge.png", label: "1 months" },
  { id: 18, image: "/assets/imgs/killskill/target.png", label: "1.5% KS XP" },
  { id: 19, image: "/assets/imgs/killskill/target.png", label: "2.5% KS XP" },
  { id: 20, image: "/assets/imgs/killskill/target.png", label: "5% KS XP" },
  { id: 21, image: "/assets/imgs/jail/prisoner.png", label: "20% BO XP" },
  { id: 22, image: "/assets/imgs/race/car.png", label: "15% Race XP" },
  { id: 23, image: "/assets/imgs/xpmarket/magic-hat.png", label: "1K Rank XP" },
  {
    id: 24,
    image: "/assets/imgs/xpmarket/magic-hat.png",
    label: "1.5K Rank XP",
  },
  {
    id: 25,
    image: "/assets/imgs/xpmarket/magic-hat.png",
    label: "2.5K Rank XP",
  },
  {
    id: 26,
    image: "/assets/imgs/xpmarket/magic-hat.png",
    label: "3.5K Rank XP",
  },
  { id: 27, image: "/assets/imgs/xpmarket/magic-hat.png", label: "5K Rank XP" },
];
